import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Componente estable a nivel de módulo: evita el remonte (y pérdida de foco)
// que ocurre al definir el campo dentro del componente padre.
export const TextField = ({ id, label, value, onChange, type = "text", readOnly = false, required = false, testid }) => (
  <div className="space-y-2">
    <Label htmlFor={id}>
      {label}
      {required && " *"}
    </Label>
    <Input
      id={id}
      type={type}
      value={value || ""}
      onChange={onChange}
      readOnly={readOnly}
      required={required}
      data-testid={testid}
    />
  </div>
);
